import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {AuthService} from "../../services/auth.service";
import {Observable} from "rxjs";
import {map, take} from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LoginGuard implements CanActivate {

  private readonly allowedRoutesForNewUser = [
    '/login/new-user',
    '/terms',
    '/user-profile',
    '/price-list',
    '/privacy',
  ];

  constructor(
    public authService: AuthService,
    public router: Router,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const currentUrl = state.url;

    return this.authService.isNew$.pipe(
      take(1),
      map((isNew) => {
        // Allow navigation for routes specified in allowedRoutesForNewUser
        if (isNew && this.allowedRoutesForNewUser.some((r) => currentUrl.includes(r))) {
          return true;
        }
        // Allow authenticated users and non-new users to continue
        if (!isNew) {
          return true;
        }
        // If the user is new, redirect to home
        this.router.navigate(['/']);
        return false;
      })
    )
  }
}
